<footer>
  <button type="button" aria-label="Return To Top" class="return-to-top" (click)="scrollToTop()">
    <span>Return To Top</span>
    <i class="fa fa-arrow-up" aria-hidden="true"></i>
  </button>

  <a class="logo" href="https://www.pa.gov">
    <img src="assets/logo-with-text.svg" alt="Commonwealth of Pennsylvania home" />
  </a>

  <span class="describtion">Proudly founded in 1681 as a place of tolerance and freedom.</span>

  <div class="social-media">
    <a class="social-icon facebook" matTooltip="Follow on Facebook" matTooltipClass="social-media-tool-tip" href="https://www.facebook.com/PennsylvaniaGov/" aria-label="Facebook">
      <fa-icon [icon]="faFacebook"></fa-icon>
    </a>

    <a class="social-icon instagram"
       matTooltip="Follow on Instagram"
       matTooltipClass="social-media-tool-tip"
       href="https://www.instagram.com/governorshapiro/?hl=en"
       aria-label="Instagram">
      <fa-icon [icon]="faInstagram"></fa-icon>
    </a>

    <a class="social-icon x" matTooltip="Follow on X" matTooltipClass="social-media-tool-tip" href="https://twitter.com/PennsylvaniaGov" aria-label="X (Twitter)">
      <fa-icon [icon]="faX"></fa-icon>
    </a>

    <a matTooltip="Follow on Flickr" matTooltipClass="social-media-tool-tip" class="social-icon flickr" href="https://www.flickr.com/photos/pagovernor/" aria-label="Flickr">
      <fa-icon [icon]="faFlickr"></fa-icon>
    </a>

    <a matTooltip="Follow on Linkedin" matTooltipClass="social-media-tool-tip" class="social-icon linkedin" href="https://www.linkedin.com/in/repshapiro/" aria-label="LinkedIn">
      <fa-icon [icon]="faLinkedIn"></fa-icon>
    </a>
  </div>

  <div class="links top-services">
    <span>Top services</span>
    <a href="https://www.pa.gov/services/vote/register-to-vote" target="_self">Register to Vote</a>
    <a href="https://www.pa.gov/agencies/dmv/find-a-location" target="_self">Find a DMV</a>
    <a href="https://www.pa.gov/agencies/health/programs/vital-records/birth-certificates" target="_self">Get a Birth Certificate</a>
    <a href="https://www.pa.gov/services/dmva/subscribe-to-veterans--registry-and-monthly-publication" target="_self">Join the Veterans Registry</a>
  </div>

  <div class="links pagov">
    <span>PA.gov</span>

    <a href="https://employment.pa.gov/Pages/jobopportunities.aspx" target="_blank">
      Careers &amp; Internships
      <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
    </a>

    <a href="https://pennwatch.pa.gov/Pages/default.aspx" target="_blank">
      PennWatch
      <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
    </a>

    <a href="https://www.openrecords.pa.gov/RTKL/CitizensGuide.cfm" target="_blank">
      Right-to-Know Law
      <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
    </a>
  </div>

  <div class="footer-beam">
    <span class="copyright">Copyright © {{ currentYear }} Commonwealth of Pennsylvania. All rights reserved.</span>

    <div class="link-group">
      <a href="https://www.pa.gov/accessibility-policy" target="_self">Accessibility</a>
      <span>|</span>
      <a href="https://www.pa.gov/privacy-policy" target="_self">Privacy &amp; Disclaimers</a>
      <span>|</span>
      <a href="https://www.pa.gov/translation-disclaimer" target="_self">Translation Disclaimer</a>
      <span>|</span>
      <a href="https://www.pa.gov/security-policy" target="_self">Security</a>
    </div>
  </div>
</footer>
